import TeacherDashboard from '../../components/dashboard/TeacherDashboard'

const Dashboard = () => {
  return <TeacherDashboard />
}

export default Dashboard